/** API route map: URLS.Controller.PayrollWcPolicies */
export const PayrollWcPolicies = {
      Name: 'PayrollWcPolicies/',
      GetAll: 'getall',
      Add: 'add',
      Delete: 'delete',
      Update: 'update',
};
